import React from 'react';
import { Check } from 'lucide-react';
import { images } from '../mockData';

export const CowCare = ({ t }) => {
  const points = [
    t.cowCarePoint1,
    t.cowCarePoint2,
    t.cowCarePoint3,
    t.cowCarePoint4
  ];

  const careImages = [
    images.cowCare.care1,
    images.cowCare.care2,
    images.cowCare.care3
  ];

  return (
    <section className="py-20 bg-brand-lightBlue/30">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold font-serif text-brand-navy mb-4">
            {t.cowCareTitle}
          </h2>
          <p className="text-xl text-brand-pink font-semibold mb-4">
            {t.cowCareSubtitle}
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              {t.cowCareDesc}
            </p>

            {/* Points List */}
            <div className="space-y-4">
              {points.map((point, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border-l-4 border-brand-pink transform transition-all duration-200 hover:shadow-md hover:translate-x-2"
                >
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-whatsapp flex items-center justify-center">
                    <Check className="h-4 w-4 text-white" />
                  </div>
                  <p className="text-gray-700 font-medium">{point}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 relative rounded-2xl overflow-hidden shadow-xl group">
              <img
                src={careImages[0]}
                alt="Happy desi cows grazing freely at RajDarshan Tandon Dairy farm near Raipur — open pasture, natural feeding for A2 milk"
                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/30 to-transparent"></div>
            </div>
            <div className="relative rounded-2xl overflow-hidden shadow-lg group">
              <img
                src={careImages[1]}
                alt="Farmer hand-feeding desi cow with fresh fodder at RajDarshan dairy farm — ethical animal care for pure A2 milk production"
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-pink/30 to-transparent"></div>
            </div>
            <div className="relative rounded-2xl overflow-hidden shadow-lg group">
              <img
                src={careImages[2]}
                alt="Desi cow in a clean, hygienic dairy shed at RajDarshan Farms Raipur — cows treated with dignity for bina milawat pure milk"
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
